import Message from "./message";
import { connect } from 'react-redux';

function Messages(props) {

    const renderMessages = () => {

        let messages = props.chat.messages.map((m, i) => {

            let type = m.type,
                image = props.chat.image,
                senderName = m.name,
                ref = props.messagesRefs.current[i],
                // * loading more messages should not change the current messages ids.
                mesgId = props.chat.messages.length - i;

            if (m.isHistory && type === "A") {
                image = m.image;
                senderName = m.userName;
            }

            if (props.chat.type === "internal") {
                type = m.from === props.supervisorId + "M" ? "A" : "U";
                senderName = type === "A" ? props.name : props.chat.fullname;
            }

            return <Message
                childref={ref}
                key={`m_${mesgId}`}
                id={`m_${mesgId}`}
                senderName={senderName}
                text={m.text}
                type={type}
                channel={props.chat.channel || props.chat.type}
                media={m.media}
                image={image}
                mediaType={m.mediaType}
                url={m.url}
                from={m.from}
                isHistory={m.isHistory}
                date={m.date}
                reference={m.reference}
                photo={props.agent ? props.agent.photo : props.image} />
        });

        return messages;
    }

    return (
        <div className="meesages-list-hist position-relative top-0 start-0">
            {renderMessages()}
            <div ref={props.lastMessage}></div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        image: state.supervisor.image,
        name: state.supervisor.fullname
    };
};

export default connect(mapStateToProps, {})(Messages);